import { getClubs, createClub, uploadImage, updateClub,deleteClub } from '../../Utils/apiServices';
import { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  FormControlLabel,
  Checkbox,
  Stack,
  InputAdornment,
  Chip,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from '../../Components/ConfirmDialog';

const Clubs = () => {
  const [clubs, setClubs] = useState([]);
  const [filteredClubs, setFilteredClubs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);
  const [newClub, setNewClub] = useState({
    name: '',
    location: '',
    image: '',
    id: '',
    website: '',
    email: '',
    about: '',
    champion_available: false
  });
  const [editingClub, setEditingClub] = useState(null);
  const [deleteClubId, setDeleteClubId] = useState(null);
  const [deleteClubDialogOpen, setDeleteClubDialogOpen] = useState(false);
  const [deleteClubLoading, setDeleteClubLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getClubs().then((response) => {
      setClubs(response.data.data);
      setFilteredClubs(response.data.data);
    });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await uploadImage(formData);
        if (editingClub) {
          setEditingClub({
            ...editingClub,
            image: response.data.file[0]
          });
        } else {
          setNewClub({
            ...newClub,
            image: response.data.file[0]
          });
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.name === 'club_id' ? Number(e.target.value) : 
                  e.target.name === 'champion_available' ? e.target.checked : 
                  e.target.value;
    setNewClub({
      ...newClub,
      [e.target.name]: value
    });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        name: newClub.name,
        location: newClub.location,
        image: newClub.image,
        website: newClub.website,
        email: newClub.email,
        about: newClub.about,
        champion_available: newClub.champion_available
      };
      const response = await createClub(payload);
      setClubs([...clubs, response.data.data]);
      handleClose();
      setNewClub({
        name: '',
        location: '',
        image: '',
        website: '',
        email: '',
        about: '',
        champion_available: false
      });
    } catch (error) {
      console.error('Error creating club:', error);
    }
  };

  const handleClubClick = (clubId,champion_available) => {
    navigate(`/clubs/${clubId}/${champion_available}`);
  };

  const handleEditClick = (club) => {
    setEditingClub({
      id: club.id,
      name: club.name,
      location: club.location,
      image: club.image || '',
      website: club.website || '',
      email: club.email || '',
      about: club.about || '',
      champion_available: club.champion_available || club.campion_available || false,
      isEditing: true
    });
  };

  const handleEditChange = (e) => {
    console.log(e.target.name,'12');
    const value = e.target.name === 'champion_available' ? e.target.checked : e.target.value;
    setEditingClub({
      ...editingClub,
      [e.target.name]: value
    });
  };

  const handleEditCancel = () => {
    setEditingClub(null);
  };

  const handleEditSubmit = async (clubId) => {
    try {
      const payload = {
        id: clubId,
        name: editingClub.name,
        location: editingClub.location,
        image: editingClub.image,
        website: editingClub.website,
        email: editingClub.email,
        about: editingClub.about,
        champion_available: editingClub.champion_available
      };
      const response = await updateClub(payload);
      
      setClubs(clubs.map(club => {
        if (club.id === clubId) {
          return {
            ...club,
            ...response.data.data
          };
        }
        return club;
      }));
      
      setEditingClub(null);
    } catch (error) {
      console.error('Error updating club:', error);
    }
  };

  const openDeleteClubConfirm = (clubId) => {
    setDeleteClubId(clubId);
    setDeleteClubDialogOpen(true);
  };

  const closeDeleteClubConfirm = () => {
    if (deleteClubLoading) return;
    setDeleteClubDialogOpen(false);
    setDeleteClubId(null);
  };

  const confirmDeleteClub = async () => {
    if (deleteClubId == null) return;
    setDeleteClubLoading(true);
    try {
      await deleteClub({ id: deleteClubId });
      setClubs(clubs.filter(club => club.id !== deleteClubId));
      setDeleteClubDialogOpen(false);
      setDeleteClubId(null);
    } catch (error) {
      console.error('Error deleting club:', error);
    } finally {
      setDeleteClubLoading(false);
    }
  };

  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    
    const filtered = clubs.filter(club => 
      (club.name?.toLowerCase() || '').includes(term) ||
      (club.location?.toLowerCase() || '').includes(term)
    );
    
    setFilteredClubs(filtered);
  };

  return (
    <Box>
      {/* Colorful page banner */}
      <Box
        sx={{
          mb: 3,
          p: 2.5,
          borderRadius: 3,
          background: 'linear-gradient(135deg, #ec4899 0%, #a855f7 50%, #6366f1 100%)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 8px 24px rgba(168,85,247,0.3)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -40,
            right: -40,
            width: 150,
            height: 150,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.3 }}>🏆 Clubs Management</Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>Manage clubs, their events, results and champions</Typography>
        </Box>
        <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
          <Typography variant="h3" sx={{ fontWeight: 800, lineHeight: 1 }}>{clubs.length}</Typography>
          <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.7rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Total Clubs</Typography>
        </Box>
      </Box>

      <ConfirmDialog
        open={deleteClubDialogOpen}
        title="Delete club"
        message="Are you sure you want to delete this club? This action cannot be undone."
        confirmLabel="Delete"
        onCancel={closeDeleteClubConfirm}
        onConfirm={confirmDeleteClub}
        loading={deleteClubLoading}
      />

      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 2.5,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between">
          <TextField
            placeholder="Search clubs by name or location..."
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearch}
            sx={{ maxWidth: { sm: 380 } }}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={handleOpen}
            startIcon={<AddIcon />}
            sx={{ flexShrink: 0 }}
          >
            Add Club
          </Button>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
          Showing {filteredClubs.length} of {clubs.length} clubs
        </Typography>
      </Paper>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Create New Club</DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            label="Club Name"
            fullWidth
            margin="dense"
            value={newClub.name}
            onChange={handleChange}
          />
          <TextField
            name="location"
            label="Location"
            fullWidth
            margin="dense"
            value={newClub.location}
            onChange={handleChange}
          />
          <TextField
            name="website"
            label="Website"
            fullWidth
            margin="dense"
            value={newClub.website}
            onChange={handleChange}
          />
          <TextField
            name="email"
            label="Email"
            fullWidth
            margin="dense"
            value={newClub.email}
            onChange={handleChange}
          />
          <TextField
            name="about"
            label="About"
            fullWidth
            margin="dense"
            multiline
            rows={4}
            value={newClub.about}
            onChange={handleChange}
          />
          <FormControlLabel
            control={
              <Checkbox
                name="champion_available"
                checked={newClub.champion_available}
                onChange={handleChange}
              />
            }
            label="Champion Available"
            sx={{ mt: 1 }}
          />
          <div style={{ marginTop: 16 }}>
            <input
              type="file"
              onChange={handleImageChange}
              style={{ display: 'none' }}
              id="create-image-upload"
            />
            <label htmlFor="create-image-upload">
              <Button
                component="span"
                variant="outlined"
                fullWidth
              >
                Upload Image
              </Button>
            </label>
            {newClub.image && (
              <Box mt={2}>
                <img 
                  src={newClub.image} 
                  alt="New Club"
                  style={{ height: 100 }}
                />
              </Box>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">Create</Button>
        </DialogActions>
      </Dialog>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'auto',
        }}
      >
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                '& .MuiTableCell-head': {
                  bgcolor: 'grey.50',
                  color: 'text.secondary',
                  fontWeight: 600,
                  fontSize: '0.8125rem',
                  letterSpacing: '0.02em',
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  py: 1.5,
                  whiteSpace: 'nowrap',
                },
              }}
            >
              <TableCell>ID</TableCell>
              <TableCell>Club Name</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Website</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>About</TableCell>
              <TableCell>Champion</TableCell>
              <TableCell>Image</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredClubs.map((club) => (
              <TableRow
                key={club.id}
                hover
                sx={{ '&:last-child td': { borderBottom: 0 }, transition: 'background-color 0.15s' }}
              >
                <TableCell>{club.id}</TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <TextField
                      name="name"
                      value={editingClub?.name}
                      onChange={handleEditChange}
                      size="small"
                    />
                  ) : (
                    <Button
                      onClick={() => handleClubClick(club.id, club.campion_available)}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        color: 'primary.main',
                        p: 0,
                        minWidth: 0,
                        textAlign: 'left',
                      }}
                    >
                      {club.name}
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <TextField
                      name="location"
                      value={editingClub?.location}
                      onChange={handleEditChange}
                      size="small"
                    />
                  ) : (
                    club.location
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <TextField
                      name="website"
                      value={editingClub?.website}
                      onChange={handleEditChange}
                      size="small"
                    />
                  ) : (
                    <a href={club.website} target="_blank" rel="noopener noreferrer">
                      {club.website}
                    </a>
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <TextField
                      name="email"
                      value={editingClub?.email}
                      onChange={handleEditChange}
                      size="small"
                    />
                  ) : (
                    <a href={`mailto:${club.email}`}>{club.email}</a>
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <TextField
                      name="about"
                      value={editingClub?.about}
                      onChange={handleEditChange}
                      size="small"
                      multiline
                      rows={2}
                    />
                  ) : (
                    <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {club.about}
                    </div>
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <Checkbox
                      name="champion_available"
                      checked={editingClub?.champion_available}
                      onChange={handleEditChange}
                    />
                  ) : (
                    <Chip
                      label={(club.champion_available || club.campion_available) ? 'Yes' : 'No'}
                      size="small"
                      color={(club.champion_available || club.campion_available) ? 'success' : undefined}
                      variant={(club.champion_available || club.campion_available) ? 'filled' : 'outlined'}
                      sx={{ fontWeight: 600 }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {editingClub?.id === club.id ? (
                    <div>
                      <input
                        type="file"
                        onChange={handleImageChange}
                        style={{ display: 'none' }}
                        id={`image-upload-${club.id}`}
                      />
                      <label htmlFor={`image-upload-${club.id}`}>
                        <Button
                          component="span"
                          variant="outlined"
                          size="small"
                          sx={{ mr: 1 }}
                        >
                          Upload Image
                        </Button>
                      </label>
                      {editingClub?.image && (
                        <img 
                          src={editingClub.image} 
                          alt="Club"
                          style={{ height: 50, marginLeft: 10 }}
                        />
                      )}
                    </div>
                  ) : (
                    club?.image && (
                      <img 
                        src={club.image} 
                        alt="Club"
                        style={{ height: 50 }}
                      />
                    )
                  )}
                </TableCell>
                <TableCell align="right">
                  {editingClub?.id === club.id ? (
                    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                      <IconButton
                        key="edit-save"
                        onClick={() => handleEditSubmit(club.id)}
                        size="small"
                        color="primary"
                        sx={{ border: '1px solid', borderColor: 'divider' }}
                        aria-label="Save"
                      >
                        <SaveIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        key="edit-cancel"
                        onClick={handleEditCancel}
                        size="small"
                        sx={{ border: '1px solid', borderColor: 'divider' }}
                        aria-label="Cancel"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  ) : (
                    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                      <IconButton
                        onClick={() => handleEditClick(club)}
                        size="small"
                        color="primary"
                        sx={{ border: '1px solid', borderColor: 'divider' }}
                        aria-label="Edit"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={() => openDeleteClubConfirm(club.id)}
                        size="small"
                        color="error"
                        sx={{ border: '1px solid', borderColor: 'divider' }}
                        aria-label="Delete"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Clubs;